import Vue from 'vue'
import App from './App'
import router from './router'
import {store} from './Store'
import firebase from 'firebase/app'
import  './config/FirebaseInit'
import BootstrapVue from 'bootstrap-vue' 
                  // import * as VueGoogleMaps from 'vue2-google-maps'
// import VueTypedJs from 'vue-typed-js'
import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

import Carousel3d from 'vue-carousel-3d'
import VModal from 'vue-js-modal'
import ProductZoomer from 'vue-product-zoomer'
import zoom from 'vue-image-zoom';
import 'vue-image-zoom/dist/vue-image-zoom.css';
import VueCharts from 'hchs-vue-charts';
 

// import VeeValidate from 'vee-validate';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// const router = new Router({
//   routes,
//   mode:'history'
// })
// import jQuery from 'jQuery'
// global.jQuery = jQuery
// global.$ = jQuery
Vue.use(zoom);
Vue.use(window.VueCharts);
Vue.use(VueFormWizard)
Vue.use(ProductZoomer)
Vue.use(VModal)
Vue.use(Carousel3d)
const VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo)
Vue.use(BootstrapVue);
Vue.use(ElementUI);
// Vue.use(VueTypedJs)

// Vue.use(VeeValidate);
Vue.config.productionTip = false

export const bus = new Vue()

let app;
firebase.auth().onAuthStateChanged(user => {
  if(!app) {
    new Vue({
      store:store,
      el: '#app',
      router,
      render: h => h(App)
    });
  }
})


// Vue.use(VueGoogleMaps, {
//  load: {
//    key: '',
//    v: 'quarterly',
  
//  },

// })
/* eslint-disable no-new */




// WEBPACK FOOTER //
// ./src/main.js